import React, { FC } from "react";
import NormalButton from "components/Buttons/NormalButton";
import ProductCheckbox from "../ProductCheckbox";

const ProductsListEditModalOptions: FC<{
  editProductList?: number;
  productOptions: {
    id: number;
    name: string;
    children: [] | any[];
  }[];
  register: Function;
  loading: boolean;
}> = ({
  editProductList,
  productOptions,
  register,
  loading,
}) => {
  return (
    <div className={`${editProductList ? "block p-4" : "hidden"}`}>
      <p className="text-[13px] leading-5">Options:</p>
      {productOptions?.map((productOption) => {
        return (
          <div
            className={`space-y-1 ${
              productOption?.children?.length > 0 ? "block" : "hidden"
            }`}
            key={productOption.id}
          >
            <p className="text-[13px] leading-5 ml-[30px]">
              {productOption?.name}
            </p>
            {productOption?.children?.length > 0
              ? productOption?.children?.map((productOptionChildren) => {
                  return (
                    <div
                      className="flex w-full text-[13px] leading-5 font-bold justify-between pl-16"
                      key={productOptionChildren.id}
                    >
                      <label
                        htmlFor={`productOption.${productOptionChildren.id}`}
                        className="max-w-[160px] truncate md:max-w-[250px] lg:max-w-[300px]"
                      >
                        {productOptionChildren?.name}
                      </label>
                      <ProductCheckbox
                        name={`productOption.${productOptionChildren?.id}`}
                        register={register}
                      />
                    </div>
                  );
                })
              : null}
          </div>
        );
      })}
      <NormalButton
        buttonName="Save"
        className={`border border-black rounded px-2 mt-5 mx-auto hover:bg-[rgb(239,239,239)] ${
          editProductList ? "block lg:hidden" : "hidden"
        }`}
        buttonType="submit"
        icon={loading ? "icon-spin4" : ""}
        loading={loading}
      />
    </div>
  );
};

export default ProductsListEditModalOptions;
